import { Typography, Flex, Button, Dropdown, MenuProps } from 'antd'
import {
  createRouteForLink,
  getBranchFromPathUrl,
} from '@/utils/helpers/urlHelper'
import { PlusOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { pageUrl } from '@/constants/url'
import { useGetCategories } from '@/hooks/category/useGetCategories'
import { servicePermissions } from '@/constants/permissions'
import { usePermissions } from '@/hooks/commons/usePermissions'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

const { Title, Text } = Typography

export const HeadingService = () => {
  const { t } = useTranslation('catalog')
  const items: MenuProps['items'] = useMemo(() => {
    return [
      {
        label: t('catalog.service.new.service'),
        key: '1',
      },
      {
        label: t('catalog.new.category'),
        key: '2',
      },
      {
        label: t('catalog.service.new.bundle'),
        key: '3',
      },
    ]
  }, [t])
  const { havePermissionAccess } = usePermissions()
  const branch = getBranchFromPathUrl()
  const { data: categories } = useGetCategories({ branch })
  const navigate = useNavigate()
  const handleClickMenu = (menu: { key: string }) => {
    if (menu.key === items[1]?.key) {
      navigate(`${createRouteForLink(pageUrl.services)}?addCategory=true`)
    } else if (menu.key === items[0]?.key) {
      navigate(createRouteForLink(pageUrl.servicesAdd))
    } else if (menu.key === items[2]?.key) {
      navigate(`${createRouteForLink(pageUrl.bundles)}?addBundle=true`)
    }
  }
  return (
    <Flex justify="space-between" align="center">
      <div>
        <Title level={3} style={{ marginTop: 0, marginBottom: 4 }}>
          {t('menu.services')}
        </Title>
        <Text type="secondary">{t('catalog.service.desc')} </Text>
      </div>
      {!!categories?.length &&
        havePermissionAccess({ permission: servicePermissions.create }) && (
          <Dropdown
            placement="bottomRight"
            trigger={['click']}
            menu={{ items, onClick: handleClickMenu }}
          >
            <Button
              icon={<PlusOutlined />}
              size="large"
              color="primary"
              type="primary"
            >
              {t('catalog.service.add.new')}
            </Button>
          </Dropdown>
        )}
    </Flex>
  )
}
